// extracted by mini-css-extract-plugin
export default {"hideFromAddressBookMessage":"jnZOSekTct"};